<template>
  <div style="padding: 20px 20px;overflow-y: auto;height:100vh;">
    <pre style="width: 100%;white-space: pre-wrap;">
      노무법인 유연 카카오 로그인 개인정보처리방침

      시행일: 2025년 11월 3일

      ⸻

      제1조 (목적)

      이 개인정보처리방침은 노무법인 유연(이하 “회사”)이 제공하는 서비스에서 카카오 로그인을 통하여 제공 또는 수집되는 이용자의 개인정보 처리에 대해 안내하기 위해 마련되었습니다. 본 방침은 「개인정보 보호법」 및 카카오 로그인 관련 지침을 준수합니다.

      ⸻

      제2조 (수집하는 개인정보 항목 및 수집방법)

      1. 수집 항목
      	•	필수 항목:
      • 카카오 계정 식별자(회원번호 또는 ID)
      • 닉네임
      • 이메일 주소
      • 이름
      • 전화번호
      	•	선택 항목:
      • 없음

      ※ 필수 항목은 서비스 제공 및 본인 확인 등을 위해 반드시 필요한 정보입니다.

      ⸻

      2. 수집방법

      회사는 이용자가 카카오 로그인을 수행하는 과정에서, 카카오에서 제공하는 API를 통해 동의된 항목에 한하여 개인정보를 수집합니다.
      또한 서비스 이용 과정에서 추가 정보 입력이 필요한 경우, 별도의 동의 절차를 거칩니다.

      ⸻

      제3조 (개인정보의 처리 목적)

      회사는 수집한 개인정보를 다음의 목적으로 처리합니다.
      	1.	카카오 계정을 이용한 간편 로그인 제공
      	2.	회원 식별 및 본인 확인
      	3.	이용자 문의 대응 및 서비스 운영
      	4.	전화번호 기반의 고객 연락 및 서비스 고지

      ⸻

      제4조 (개인정보의 보유 및 이용기간)
      	1.	회사는 개인정보 수집·이용 목적 달성 또는 회원 탈퇴 시 지체 없이 개인정보를 파기합니다.
      	2.	단, 관련 법령에 따라 아래 항목은 정해진 기간 동안 보관할 수 있습니다.
      • 계약 및 청약철회에 관한 기록: 5년
      • 결제 및 재화 공급에 관한 기록: 5년
      • 소비자 불만 및 분쟁 처리에 관한 기록: 3년

      ⸻

      제5조 (개인정보의 제3자 제공)

      회사는 이용자의 개인정보를 제3자에게 제공하지 않습니다.
      다만 법령에 근거하거나 이용자의 별도 동의가 있는 경우 예외적으로 제공할 수 있습니다.

      ⸻

      제6조 (개인정보 처리위탁)

      회사는 서비스 제공을 위해 필요한 경우 개인정보 처리 업무를 외부에 위탁할 수 있으며, 위탁 시 관련 법령에 따라 필요한 보호조치를 이행합니다.

      ⸻

      제7조 (이용자의 권리)

      이용자는 자신의 개인정보에 대해 열람, 정정, 삭제, 처리정지 및 동의 철회를 요청할 수 있으며, 회사는 이를 지체 없이 처리합니다.

      ⸻

      제8조 (쿠키의 사용)

      회사는 서비스 품질 향상을 위해 쿠키를 사용할 수 있으며, 이용자는 브라우저 설정을 통해 쿠키 저장을 거부할 수 있습니다. 다만 일부 기능 이용에 제한이 있을 수 있습니다.

      ⸻

      제9조 (개인정보의 안전성 확보조치)

      회사는 개인정보 보호를 위해 다음의 조치를 시행합니다.
      	•	개인정보 접근 권한 최소화
      	•	접근 통제 시스템 운영
      	•	암호화 및 안전한 저장
      	•	보안 프로그램 설치 및 점검
      	•	접속 기록 관리 및 위·변조 방지

      ⸻

      제10조 (개정 고지)

      본 개인정보처리방침은 2025년 11월 3일부터 시행됩니다.
      변경사항 발생 시, 최소 7일 전에 서비스 내 공지사항 등을 통해 고지합니다.
      중대한 변경은 30일 전부터 공지할 수 있습니다.

      ⸻

      개인정보보호책임자
      	•	성명: 이종진
      	•	직위: 개인정보보호팀장
      	•	이메일: jlee@neosaic.services
      	•	전화번호: 010-6890-9325

    </pre>

  </div>
</template>
<script>
  import Vue from 'vue';
  import { mapGetters, mapActions } from 'vuex'
  import { getAction } from '@/network/manage';
  import moment from 'moment/moment';
  export default {
    name: 'Policy',
    components: {

    },
    data() {
      return {

      }
    },
    mounted() {

    },
    methods:{

    }
  }
</script>

<style scoped>
</style>
